import type { ComponentProps } from "react";

const PDFFileIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="63"
      height="60"
      viewBox="0 0 63 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.7214 58.6046H23.0235C19.1703 58.6046 16.0467 55.481 16.0467 51.6279V8.37212C16.0467 4.51896 19.1703 1.39535 23.0235 1.39535H41.6317L60.6982 20.4617V51.6279C60.6982 55.481 57.5746 58.6046 53.7214 58.6046Z"
        fill="#E9ECEF"
        stroke="#CED4DA"
        strokeWidth="2.79071"
      />
      <rect
        y="26.5115"
        width="41.8607"
        height="24.4186"
        rx="4.88374"
        fill="#EF4444"
      />
      <path
        d="M6.9375 44.6511V32.981H11.0973C12.0053 32.981 12.7574 33.1462 13.3539 33.4767C13.9503 33.8072 14.3967 34.2593 14.693 34.8329C14.9893 35.4027 15.1375 36.0448 15.1375 36.759C15.1375 37.4769 14.9874 38.1228 14.6873 38.6964C14.391 39.2662 13.9427 39.7183 13.3425 40.0526C12.746 40.3831 11.9958 40.5483 11.0916 40.5483H8.23103V39.0554H10.9321C11.5057 39.0554 11.9711 38.9566 12.3282 38.7591C12.6853 38.5577 12.9474 38.2842 13.1145 37.9385C13.2817 37.5928 13.3653 37.1996 13.3653 36.759C13.3653 36.3183 13.2817 35.927 13.1145 35.5851C12.9474 35.2432 12.6834 34.9754 12.3225 34.7816C11.9654 34.5879 11.4943 34.491 10.9093 34.491H8.6983V44.6511H6.9375Z"
        fill="white"
      />
      <path
        d="M20.9797 44.6511H17.2017V32.981H21.0994C22.2429 32.981 23.2249 33.2146 24.0454 33.6819C24.866 34.1453 25.4947 34.812 25.9316 35.682C26.3723 36.5481 26.5926 37.5871 26.5926 38.799C26.5926 40.0146 26.3704 41.0593 25.9259 41.933C25.4852 42.8068 24.847 43.4792 24.0112 43.9503C23.1755 44.4175 22.165 44.6511 20.9797 44.6511ZM18.9625 43.1126H20.8828C21.7718 43.1126 22.5107 42.9454 23.0995 42.6111C23.6883 42.273 24.129 41.7849 24.4215 41.1467C24.714 40.5047 24.8603 39.7221 24.8603 38.799C24.8603 37.8834 24.714 37.1066 24.4215 36.4683C24.1328 35.8301 23.7016 35.3458 23.128 35.0153C22.5544 34.6848 21.8421 34.5195 20.9911 34.5195H18.9625V43.1126Z"
        fill="white"
      />
      <path
        d="M28.7822 44.6511V32.981H36.0191V34.4967H30.543V38.0525H35.5006V39.5625H30.543V44.6511H28.7822Z"
        fill="white"
      />
    </svg>
  );
};

export default PDFFileIcon;
